module.exports = { "default": require("core-js/library/fn/math/cosh"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/cosh.js
// module id = p7HX
// module chunks = 0